import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const timerecordBudgetDataClassName = DataClassName.TIMERECORD_BUDGET
const timerecordBudgetEndpoint = PisaDataClassEndpoint.TIMERECORD_BUDGET

export function pisaTimerecordBudgetDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(timerecordBudgetDataClassName, {
    title: timerecordBudgetDataClassName,
    restApi: createPisaRestApiConfig(timerecordBudgetEndpoint),
    attributes,
  })
}
